module.exports = __webpack_public_path__ + "static/media/Braden-Walker-Resume.a2774cad.pdf";